/**
 * Pure diff of two adapter lists, surfacing rank, enabled and range changes per
 * adapter. Used by the save confirmation dialog (Экран B). Ported from the
 * prototype's mutation algebra (only the diff part is needed here).
 */

import type { AdapterRow } from './types'

export interface DiffEntry {
  adapterId: number
  name: string
  changes: string[]
}

export function diff(before: AdapterRow[], after: AdapterRow[]): DiffEntry[] {
  const beforeRank = rankMap(before)
  const afterRank = rankMap(after)
  const beforeById = byId(before)

  const entries: DiffEntry[] = []
  after.forEach((row) => {
    const prev = beforeById.get(row.adapterId)
    const changes: string[] = []
    if (!prev) {
      changes.push('добавлен')
    } else {
      const r0 = beforeRank.get(row.adapterId)!
      const r1 = afterRank.get(row.adapterId)!
      if (r0 !== r1) changes.push(`приоритет ${r0} → ${r1}`)
      if (prev.enabled !== row.enabled) changes.push(row.enabled ? 'включён' : 'выключен')
      if (prev.minDeposit !== row.minDeposit || prev.maxDeposit !== row.maxDeposit)
        changes.push(
          `диапазон ${fmt(prev.minDeposit)}–${fmt(prev.maxDeposit)} → ${fmt(row.minDeposit)}–${fmt(row.maxDeposit)}`
        )
      if (prev.useTrafficType !== row.useTrafficType)
        changes.push(`трафик ${prev.useTrafficType} → ${row.useTrafficType}`)
    }
    if (changes.length) entries.push({ adapterId: row.adapterId, name: row.name, changes })
  })

  // Removed adapters (present before, absent after).
  const afterIds = new Set(after.map((a) => a.adapterId))
  before.forEach((row) => {
    if (!afterIds.has(row.adapterId)) {
      entries.push({ adapterId: row.adapterId, name: row.name, changes: ['удалён'] })
    }
  })

  return entries
}

function rankMap(arr: AdapterRow[]): Map<number, number> {
  return new Map(arr.map((a, i) => [a.adapterId, i + 1]))
}
function byId(arr: AdapterRow[]): Map<number, AdapterRow> {
  return new Map(arr.map((a) => [a.adapterId, a]))
}
function fmt(n: number): string {
  return n.toLocaleString('ru-RU')
}
